import { render, staticRenderFns } from "./GroupTaxaSearchButton.vue?vue&type=template&id=112affe6"
import script from "./GroupTaxaSearchButton.vue?vue&type=script&lang=js"
export * from "./GroupTaxaSearchButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports